import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  selectAllBuyerSettings,
  selectBuyerSettings,
  selectCompanySettings,
  selectError,
  selectFailedLoginAttempts,
  selectIsAuthenticated,
  selectLoading,
  selectUser,
  selectUserType,
} from './selectors/auth.selectors';

@Injectable({ providedIn: 'root' })
export class AuthSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly loading = this._store.selectSignal(selectLoading);

  public readonly error = this._store.selectSignal(selectError);

  public readonly currentUser = this._store.selectSignal(selectUser);

  public readonly isAuthenticated = this._store.selectSignal(
    selectIsAuthenticated,
  );

  public readonly currentUserType = this._store.selectSignal(selectUserType);

  // Settings
  public readonly allBuyerSettings = this._store.selectSignal(
    selectAllBuyerSettings,
  );

  public readonly currentBuyerSettings =
    this._store.selectSignal(selectBuyerSettings);

  public readonly companySettings = this._store.selectSignal(
    selectCompanySettings,
  );

  // Login
  public readonly failedLoginAttempts = this._store.selectSignal(
    selectFailedLoginAttempts,
  );
}
